<div class="SLV2-stories-popup-area">
    <button class="SLV2-stories-popup-cls-btn" (click)="close()">
        <img src="selflearnv2-ui/assets/img/self-learn-v2/close-black-icon.svg" />
    </button>

    <div class="SLV2-stories-list-wrap">
        <div class="row SLV2-sm-gap SLV2-leading-zero-list">
            <div *ngFor="let story of storiesList" class="col-md-6 col-6">
                <app-story-card [story]="story"></app-story-card>
            </div>
        </div>
    </div>
    
</div>
